import React from 'react';

// #568: Der KayCee-Scherenschnitt als Symbol, z. B. an der KI-Suche und
// später am Knopf der KI-Seitenleiste (#512). Er ist eine CSS-Maske
// (themes/kaycee.css, `.kc-kopf`) und nimmt damit die Schriftfarbe an wie die
// Lucide-Symbole daneben. `size` wie bei Lucide.
export default function KayCeeKopf({ size = 16 }) {
  return <span className="kc-kopf" style={{ width: size, height: size }} aria-hidden="true" />;
}
